import nestAxios from './_nestAxios'

export const get = _id => nestAxios.get(`/activos-fijos-bajas/${_id}`)

export const nuevoCodigo = () => nestAxios.get('/activos-fijos-bajas/nuevo-codigo')

export const nuevo = data => nestAxios.post('/activos-fijos-bajas', data)

export const actualizar = (_id, data) => nestAxios.put(`/activos-fijos-bajas/${_id}`, data)

export const cambiarEstado = (_id, data) => nestAxios.put(`/activos-fijos-bajas/${_id}/estado`, data)

export const eliminar = _id => nestAxios.delete(`/activos-fijos-bajas/${_id}`)
